// @flow
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { api } from 'app/api';
import SimpleDate from 'app/common/classes/simple-date';

import {
  GET_CAFETERIA_CUSTOMER_ORDERS_AVAILABLE,
  convertParams,
  convertResult,
} from 'app/common/api/requests/cafeteria/customer/orders/available';

import type { Available } from '../../dataTypes/orderRequests/Available.types';


const defaultAvailable: Available = {
  dayCareOrderAvailable: null,
  klassOrderAvailable: null,
};

export default function useAvailable(customerId: string, date: SimpleDate): [
  Available,
  () => Promise<void>,
] {
  const { t } = useTranslation('cafeteria');

  const [available, setAvailable] = useState(defaultAvailable);

  const request = useCallback(async () => {
    const res = await api.request(GET_CAFETERIA_CUSTOMER_ORDERS_AVAILABLE, {
      error: t(
        'customer_orders_available_fetch_error',
        'Не удалось получить данные баланса для заявки',
      ),
      params: {
        customerId,
        date,
      },
      convertions: {
        convertParams,
        convertResult,
      },
    });

    if (res) {
      setAvailable(res);
    }
  }, [customerId, date, t]);

  return [available, request];
}
